import { AfterViewInit, Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { NotificationSettingsModalComponent } from '@app/shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { SubscriptionStartType } from '@shared/service-proxies/service-proxies';
import { ChatSignalrService } from 'app/shared/layout/chat/chat-signalr.service';
import * as moment from 'moment';
import { AppComponentBase } from 'shared/common/app-component-base';
import { SignalRHelper } from 'shared/helpers/SignalRHelper';
import { NotificationSettingsModal } from './shared/layout/modals/notification-settings-modal.component';
import { IdentityReportNotificationsSignalrService } from './admin/oii-sites/services/identity-reports-notifications-signalr.service';
import { CapacityReportNotificationsSignalrService } from './admin/capacity-sites/services/capacity-reports-notifications-signalr.service';

@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {

    subscriptionStartType = SubscriptionStartType;
    theme: string;
    installationMode = true;

    @ViewChild('loginAttemptsModal') loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild('linkedAccountsModal') linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild('changePasswordModal') changePasswordModal: ChangePasswordModalComponent;
    @ViewChild('changeProfilePictureModal') changeProfilePictureModal: ChangeProfilePictureModalComponent;
    @ViewChild('mySettingsModal') mySettingsModal: MySettingsModalComponent;
    @ViewChild('notificationSettingsModal') notificationSettingsModal: NotificationSettingsModalComponent;
    @ViewChild('notificationSubscriptionSettingsModal') notificationSubscriptionSettingsModal: NotificationSettingsModal
    @ViewChild('chatBarComponent') chatBarComponent;

    public constructor(
        injector: Injector,
        private _chatSignalrService: ChatSignalrService,
        private _userNotificationHelper: UserNotificationHelper,
        private _identityReportNotificationsSignalrService: IdentityReportNotificationsSignalrService,
        private _capacityReportNotificationsSignalrService: CapacityReportNotificationsSignalrService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
        this.theme = abp.setting.get('App.UiManagement.Theme').toLocaleLowerCase();
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        this.registerModalOpenEvents();

        if (this.appSession.application) {
            SignalRHelper.initSignalR(() => {
                this._chatSignalrService.init();
                this._identityReportNotificationsSignalrService.init();
                this._capacityReportNotificationsSignalrService.init();
            });
        }
    }

    ngAfterViewInit(): void {
        abp.signalr.autoConnect = false;
    }

    subscriptionStatusBarVisible(): boolean {
        return this.appSession.tenantId > 0 &&
            (this.appSession.tenant.isInTrialPeriod ||
                this.subscriptionIsExpiringSoon());
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this.appSession.tenant.subscriptionEndDateUtc) {
            return moment().utc().add(AppConsts.subscriptionExpireNootifyDayCount, 'days') >= moment(this.appSession.tenant.subscriptionEndDateUtc);
        }

        return false;
    }

    registerModalOpenEvents(): void {
        abp.event.on('app.show.loginAttemptsModal', this.showLoginAttemptsModal);
        abp.event.on('app.show.linkedAccountsModal', this.showLinkedAccountsModal);
        abp.event.on('app.show.changePasswordModal', this.showChangePasswordModal);
        abp.event.on('app.show.changeProfilePictureModal', this.showChangeProfilePictureModal);
        abp.event.on('app.show.changeNotificationSettingsModal', this.showNotificationSubscriptionSettingsModal);
        abp.event.on('app.show.mySettingsModal', this.showMySettingsModal);
    }

    private showLoginAttemptsModal = () => this.loginAttemptsModal.show();
    private showLinkedAccountsModal = () => this.linkedAccountsModal.show();
    private showChangePasswordModal = () => this.changePasswordModal.show();
    private showChangeProfilePictureModal = () => this.changeProfilePictureModal.show();
    private showNotificationSubscriptionSettingsModal = () => this.notificationSubscriptionSettingsModal.show();
    private showMySettingsModal = () => this.mySettingsModal.show();

    ngOnDestroy() {
        abp.event.off('app.show.loginAttemptsModal', this.showLoginAttemptsModal);
        abp.event.off('app.show.linkedAccountsModal', this.showLinkedAccountsModal);
        abp.event.off('app.show.changePasswordModal', this.showChangePasswordModal);
        abp.event.off('app.show.changeProfilePictureModal', this.showChangeProfilePictureModal);
        abp.event.off('app.show.changeNotificationSettingsModal', this.showNotificationSubscriptionSettingsModal);
        abp.event.off('app.show.mySettingsModal', this.showMySettingsModal);
    }

    getRecentlyLinkedUsers(): void {
        abp.event.trigger('app.getRecentlyLinkedUsers');
    }

    onMySettingsModalSaved(): void {
        abp.event.trigger('app.onMySettingsModalSaved');
    }
}
